import { LinkBlock } from '--root/static_types/slate/Shared';
import { Tooltip } from '--components/tooltip';
import Color from 'color';
import * as React from 'react';
import styled from 'styled-components';
import { RenderElementPropsT } from '../../utils';

export const LinkBlockRender: React.FC<RenderElementPropsT<LinkBlock>> = (props) => {
    return <StyledLink tip={props.element.children[0].text} {...props.attributes}>
        <a href={props.element.children[0].text} target="_blank"  >
            {props.children}
        </a>
    </StyledLink>
}

const StyledLink = styled(Tooltip)`
    display: inline-block;
    > a,
    > a:link {
        color: ${props => props.theme.palette.text.link};
        text-decoration: none;
    }
    > a:hover,
    > a:active {
        text-decoration: underline;
    }
    > a:visited {
        color: ${props => Color(props.theme.palette.text.link).desaturate(0.5).toString()};
    }
`;